'use strict'

import React from 'react';
import ExceptionManagement from './ExceptionManagement.jsx';

let request=require('superagent');

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
  require('./labels/english.js'),
  require('./labels/norwegian.js')
]);

class ExceptionPlanHeader extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.baselineHistory.header.exception;
    let plan=this.props.plan;
    let exceptionTitle=(level)=>{
      switch (level) {
        case "stage":
          return labels.stage;

        case "phase":
          return labels.phase;

        case "project":
          return labels.project;

        default:
          return "("+labels.unknown+": "+level+")";
      }
    };
    return (
      <span>
          {exceptionTitle(plan.level)}
          {plan.exceptionReport!==undefined && plan.exceptionReport!==null
            ? ": "+this.props.project.issues.find(issue=>issue.id===plan.exceptionReport.issue.id).title
            : plan.level==="stage" && plan.stage!==undefined && plan.stage.name!==undefined
              ? ": "+plan.stage.name
              : plan.level==="phase" && plan.phase!==undefined && plan.phase.name!==undefined
                ? ": "+plan.phase.name
                : null
          }
        </span>
    );
  }
}

class BaselineHeader extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.baselineHistory.header;
    let plan=this.props.plan;
    let details=()=>{
    switch (plan.type) {
      case "approvedPID":
        return labels.approvedPID;

      case "approvedExceptionPlan":
        return <ExceptionPlanHeader {...this.props}/>;

      case "approvedStage":
        let stage=plan.stages.find(stage=>stage.id===plan.stage.id);
        return labels.approvedStage+(stage!==undefined ? ": "+stage.name : "");

      default:
        return "("+labels.unknown+", "+plan.type+")";
    }}
    return (
      <span>
        {new Date(plan.approved).toISOString().slice(0,10)}
        <span> </span>
        {details()}
      </span>
    );
  }
}

class BaselineEntryDetails extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.baselineHistory.entry;
    let plan=this.props.plan;
    switch (this.props.plan.type) {
      case "approvedExceptionPlan":
        return (
          <ExceptionManagement
            {...this.props}
            project={Object.assign({},this.props.project,{
              requestedStageException: plan
            })}
            showDetails={true}
            viewOnly={true}
            baseline={plan.baseline}
            approved={plan}
          />
        );

      case "approvedPID":
        return (
          <div style={{paddingBottom:10}}>
            <div style={{paddingBottom:5}}>
              <a target="_blank" href={"/projects/"+this.props.project.id+"/pid/?version="+plan.pid.version}>{labels.approvedPID}</a>
            </div>
            {plan.baseline!==undefined ? (
              <div style={{paddingBottom:5}}>
                <a target="_blank" href={"/projects/"+this.props.project.id+"/plan/baseline/"+plan.baseline.version+"/"}>{labels.baselinePlan}</a> {labels.beforePIDApproval}
              </div>
            ) : null}
            <div style={{paddingBottom:5}}>
              <a target="_blank" href={"/projects/"+this.props.project.id+"/plan/baseline/"+plan.version+"/"}>{labels.newBaselinePlan}</a> {labels.afterPIDApproval}
            </div>
          </div>
        );

      case "approvedStage":
        return (
          <div style={{paddingBottom:10}}>
            <div style={{paddingBottom:5}}>
              <a target="_blank" href={"/projects/"+this.props.project.id+"/plan/stages/"+plan.stage.id+"?version="+plan.stage.version}>{labels.approvedStagePlan}</a>
            </div>
            {plan.baseline!==undefined ? (
              <div style={{paddingBottom:5}}>
                <a target="_blank" href={"/projects/"+this.props.project.id+"/plan/baseline/"+plan.baseline.version+"/"}>{labels.baselinePlan}</a> {labels.beforeStageApproval}
              </div>
            ) : null}
            <div style={{paddingBottom:5}}>
              <a target="_blank" href={"/projects/"+this.props.project.id+"/plan/baseline/"+plan.version+"/"}>{labels.newBaselinePlan}</a> {labels.afterStageApproval}
            </div>
          </div>
        );

      default:
        return (
          <div style={{color: "red", paddingBottom:10}}>
            {labels.unknownBaseline}, {this.props.plan.type}
          </div>
        );
    }
  }
}

class BaselineEntry extends React.Component {
  constructor(props) {
    super(props);
    this.state={details:false}
  }

  toggleDetails(event) {
    event.preventDefault();
    this.setState({details:!this.state.details});
  }

  render() {
    let labels=translations.getTranslation(this.props).general.baselineHistory;
    let plan=this.props.plan;
    return this.state.details ? (
      <div style={{paddingBottom: 20}}>
        <div>
          <b><BaselineHeader {...this.props}/></b>
        </div>
        <div style={{paddingLeft:45, paddingTop: 10}}>
          <BaselineEntryDetails {...this.props} plan={plan}/>
        </div>
        <a onClick={this.toggleDetails.bind(this)} href="#">{labels.hideDetails}</a>
      </div>
    ) : (
      <div>
        <a onClick={this.toggleDetails.bind(this)} href="#">
          <BaselineHeader {...this.props}/>
        </a>
      </div>
    );
  }
}

class PlanBaseline extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.baselineHistory;
    return (
      <div style={{paddingTop:10}}>
        {this.props.baseline!==undefined && this.props.baseline.length>0
          ? this.props.baseline.concat()
            .sort((a,b)=>a.approved<b.approved ? 1 : a.approved>b.approved ? -1 : 0)
            .map((plan,index)=>(
              <BaselineEntry key={index} {...this.props} plan={plan}/>
          ))
        : (
          <div>
            <i>{labels.noBaseline}</i>
          </div>
        )}
      </div>
    );
  }
}

export default class BaselineHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      showDetails:false,
      baseline: props.baseline
    };
  }

  componentWillReceiveProps(props) {
    this.setState({baseline: props.baseline});
  }

  loadHistory(event) {
    event.preventDefault();
    this.setState({showDetails:true, loading: true});
    request
      .get("/projects/"+this.props.project.id+"/plan/history/")
      .then(response=>{
        this.setState({loading:false, baseline:JSON.parse(response.text)})
      })
      .catch(error=>{
        this.setState({error: error})
      });
  }

  closeHistory(event) {
    event.preventDefault();
    this.setState({showDetails:false});
  }

  render() {
    let labels=translations.getTranslation(this.props).general.baselineHistory;
    return this.props.project.isProduct===true
      ? null
      : this.state.showDetails ?
      this.state.loading===true ? (
          <div>
            {this.state.error===undefined ? (
              <div>
                {labels.loadingHistory}
              </div>
            ) : (
              <div style={{color: "red"}}>
                {labels.errorOccuredDurligLoading}: {this.state.error.message}
              </div>
            )}
          </div>
        ) : (
          <div style={{fontFamily:"Lato"}}>
            <b>{labels.title}</b>
            <PlanBaseline {...this.props} baseline={this.state.baseline}/>
            <div style={{paddingTop:10}}>
              <a onClick={this.closeHistory.bind(this)} href="#">{labels.close}</a>
            </div>
          </div>
      ) : (
      <a onClick={this.loadHistory.bind(this)} href="#">{labels.title}</a>
    );
  }
}



// WEBPACK FOOTER //
// ./views/plan/BaselineHistory.jsx